/*
 * ProcessUserMapping.tsx
 * Author: fwunderlich
 * Date: 09.04.2024
 *
 * Copyright: DMT GmbH & Co. KG
 */

import React, {useEffect, useState} from 'react';
import {useGetUsersQuery} from '../../../redux/rtk/injectedSystemApi';
import Input from '../../global/Input';
import {useTranslation} from 'react-i18next';
import {checkPermission} from '../../../functions/functionLibrary';
import {permissions} from '../../../config/permissions';

type Props = {
    projectId: string,
    roleName: string,
    onSelection?: (id: string) => void
}

export const ProcessUserMapping = (props: Props): JSX.Element => {

    const {t} = useTranslation(['common', 'globalData']);

    const [userList, setUserList] = useState<any[]>([]);
    const [selected, setSelected] = useState<any[]>([]);
    // const [selectedHaupt, setSelectedHaupt] = useState<string>('');

    const userQuery = useGetUsersQuery({projectId: props.projectId});


    useEffect(() => {
        if (userQuery.data) {
            setUserList(userQuery.data.filter((item: any) => {
                return item.role_name === props.roleName;
            }).map((item: any) => {
                return {value: item.id, label: item.last_name + ', ' + item.first_name};
            }));
        }
    }, [userQuery]);

    // useEffect(() => {
    //     if (selected.length === 1) {
    //         setSelectedHaupt(selected[0]);
    //     }
    // }, [selected]);

    // useEffect(() => {
    //     if (props.onSelection) {
    //         props.onSelection(selected, selectedHaupt);
    //     }
    // }, [selectedHaupt]);

    return (
        <Input edit={checkPermission(permissions.editProcess)} name={'user'}
               label={t('globalData:process.' + props.roleName.toLowerCase())}
               type={'dropdown'}
               dropdownOptions={userList}
               value={selected}
               onChange={(e: any) => {
                   console.log(e);
                   setSelected(e.target.value);
                   if (props.onSelection) {
                       props.onSelection(e.target.value);
                   }
               }}/>
        // <div className={'grid'}>
        //     <div className={'col-6'}>
        //         <Input edit={true} name={'user'} label={t('globalData:process.' + props.roleName.toLowerCase())}
        //                type={'multiselect'}
        //                dropdownOptions={userList}
        //                value={selected}
        //                onChange={(e: any) => {
        //                    console.log(e);
        //                    setSelected(e.target.value);
        //                    if (props.onSelection) {
        //                        props.onSelection(e.target.value, selectedHaupt);
        //                    }
        //                }}/>
        //     </div>
        //     <div className={'col-6'}>
        //         <Input edit={true} name={'user'}
        //                label={t('main-') + t('globalData:process.' + props.roleName.toLowerCase())}
        //                type={'dropdown'}
        //                dropdownOptions={userList.filter((item) => {
        //                    return selected.indexOf(item.value) >= 0;
        //                })}
        //                value={selectedHaupt}
        //                onChange={(e: any) => {
        //                    console.log('changed');
        //                    setSelectedHaupt(e.target.value);
        //
        //                }}/>
        //     </div>
        // </div>
    );
};
